import ModalView from './Modal.view';

export default ModalView;
